module.exports = __webpack_public_path__ + "img/6e41b1d.jpg";